<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    Zhoushan Chenxi New Material Co., Ltd.
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">

                    Zhoushan Chenxi New Material Co., Ltd.（short for
Chenxi New Material）was established in 2021 at
Zhoushan, Zhejiang. We are a professional chemical
products and chemical derivatives trade distribution
company. Our main products are PPG&POP、PU
Additives、Isocyanate and PCE. We have a professional
marketing team, rich product channels and stable
customer groups. We also provide the whole chain of
marketing services and solutions, with a high market
share in automotive, household appliances,
electronics/ communications, medical, food, daily
chemicals and other fields.
<br>
<br>

                </span>
                
            </el-col>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <img src="../../../../assets/images/companyInfo.png" class="mainPic"/>
                
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "en_Main",
        components: {},
        data() {
            return {

            }
        }
    }
</script>